import { useEffect } from 'react';

import { type IAutomatProgress } from '../fragments/automat-progress-bar';
import { formatRemainingTime } from '../fragments/format-remaining-time';

export function useAutomatDocumentTitle(
  isRunning: boolean,
  progress: IAutomatProgress | null,
): void {
  useEffect(() => {
    if (!isRunning || !progress) {
      return undefined;
    }

    const originalTitle = document.title;
    const remaining =
      progress.current > 0
        ? ` · ${formatRemainingTime(Date.now() - progress.startedAt, progress.current, progress.total)}`
        : '';

    document.title = `(${progress.current}/${progress.total}${remaining}) ${originalTitle}`;

    return (): void => {
      document.title = originalTitle;
    };
  }, [isRunning, progress]);
}
